import { render, staticRenderFns } from "./member.vue?vue&type=template&id=35cdb116&scoped=true"
import script from "./member.vue?vue&type=script&lang=js"
export * from "./member.vue?vue&type=script&lang=js"
import style0 from "./member.vue?vue&type=style&index=0&id=35cdb116&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cdb116",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35cdb116')) {
      api.createRecord('35cdb116', component.options)
    } else {
      api.reload('35cdb116', component.options)
    }
    module.hot.accept("./member.vue?vue&type=template&id=35cdb116&scoped=true", function () {
      api.rerender('35cdb116', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TrainCourse/member.vue"
export default component.exports